import React, { useState, useEffect } from 'react';

const Toast = () => {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleToast = (e) => {
      const { message, type } = e.detail;
      setToast({ message, type });
      setVisible(true);

      setTimeout(() => {
        setVisible(false);
        setTimeout(() => setToast(null), 300);
      }, 5000);
    };

    window.addEventListener('showToast', handleToast);
    return () => window.removeEventListener('showToast', handleToast);
  }, []);

  if (!toast) return null;

  const colors = {
    success: { bg: '#34a853', iconColor: '#34a853' },
    info: { bg: 'black', iconColor: '#4285f4' },
    warning: { bg: '#fbbc04', iconColor: '#f9ab00' },
    error: { bg: '#ea4335', iconColor: '#ea4335' }
  };

  const style = colors[toast.type] || colors.success;

  const icons = {
    success: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={style.iconColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    info: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={style.iconColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" strokeWidth="2" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" strokeWidth="3" />
      </svg>
    ),
    warning: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={style.iconColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" strokeWidth="2" />
        <line x1="12" y1="9" x2="12" y2="13" strokeWidth="2.5" />
        <line x1="12" y1="17" x2="12.01" y2="17" strokeWidth="3.5" />
      </svg>
    ),
    error: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={style.iconColor} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" strokeWidth="2" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    )
  };

  return (
    <div style={{
      position: 'fixed',
      top: '80px',
      left: '50%',
      transform: `translateX(-50%) translateY(${visible ? '0' : '-20px'})`,
      background: 'white',
      color: 'black',
      padding: '16px 24px',
      border: `2px solid ${style.bg}`,
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
      zIndex: 30000,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '14px',
      fontWeight: 600,
      opacity: visible ? 1 : 0,
      transition: 'all 0.3s ease',
      maxWidth: '90%',
      wordWrap: 'break-word',
      pointerEvents: 'none'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
        {icons[toast.type] || icons.success}
      </div>
      <span>{toast.message}</span>
    </div>
  );
};

export default Toast;